export function yearMonthDayToMonthDayYear(dateString) {
    if (typeof dateString === 'undefined') return 'NC';
    var dateStringSplit = dateString.split('-');
    return dateStringSplit[1] + '-' + dateStringSplit[2] + '-' + dateStringSplit[0];
}